<template>
    <div>
        <el-dialog :title="'打包临时发货申请管理[' + detailsInfo.Apply_SN + ']'" :close-on-click-modal="isclose" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose">
            <div class="details-box">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">合同号 ：</div>
                            <div>
                                <span class="links" @click="goOrderdetail">{{ orders }}</span>
                            </div>
                        </div>
                    </el-col>
                    <!-- <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">申请单号 ：</div>
                            <div>
                                <span>{{ detailsInfo.Apply_SN }}</span>
                            </div>
                        </div>
                    </el-col> -->
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">配送省市：</div>
                            <div class="is-status-text">{{ addressStr }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">配送地址 ：</div>
                            <div>{{ detailsInfo.Apply_Address }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">收货人：</div>
                            <div>{{ detailsInfo.Apply_Accepter }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">收货人电话 ：</div>
                            <div>{{ detailsInfo.Apply_PhoneNumber }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">收货人手机：</div>
                            <div>{{ detailsInfo.Apply_Mobile }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">总价 ：</div>
                            <div>￥{{ Number(detailsInfo.Apply_TotalPrice).toFixed(2) }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">生效状态：</div>
                            <div>
                                <span :class="judgeColor(Apply_ValidStatusStr)">{{ Apply_ValidStatusStr }}</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">审核状态：</div>
                            <div>
                                <span :class="judgeColor(Apply_StatusStr)">{{ Apply_StatusStr }}</span>
                                <el-button type="primary" v-if="detailsInfo.Apply_BPMBizObjectID" @click="searchBpm(detailsInfo.Apply_BPMBizObjectID)">查询审批情况</el-button>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">审核备注：</div>
                            <div>
                                {{ detailsInfo.Apply_AuditNote }}
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">时间：</div>
                            <div>{{ elformatDate(detailsInfo.Apply_Addtime, 'yyyy/MM/dd HH:mm:ss') }}</div>
                        </div>
                    </el-col>
                </el-row>
                <el-table :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                    <el-table-column prop="No" show-overflow-tooltip label="箱号" align="center" width="120"></el-table-column>
                    <!-- <el-table-column prop="Type" show-overflow-tooltip label="类型" align="center" width="80"></el-table-column> -->
                    <el-table-column prop="ProductName" show-overflow-tooltip label="商品名称" align="left" width="350"></el-table-column>
                    <el-table-column prop="Amount" label="发货数量" align="center" width="80"></el-table-column>
                    <el-table-column label="备注" align="center" show-overflow-tooltip prop="Remarks"></el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
                <el-button @click="handleClose">关闭</el-button>
            </span>
        </el-dialog>
        <BPMExamine :isSwitch="isSwitch" :id="detailsInfo.Apply_BPMBizObjectID" @setSwitchClose="setSwitchClose" v-if="isSwitch"></BPMExamine>
    </div>
</template>

<script>
import { getDisplayAddressStr } from '@/utils/utils.js';
import BPMExamine from '@/components/BPMExamine';
export default {
    components: {
        BPMExamine
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: () => false
        },
        id: {
            type: Number
        },
        orders: {
            type: String
        }
    },
    data() {
        return {
            isShowDialog: false,
            isSubmitDialog: false,
            isclose: false,
            tableData: [],
            tableData1: [],
            appropriationrecord: [],
            isSwitch: false, // bpm审核弹窗

            detailsInfo: {
                Apply_Accepter: '',
                Apply_Address: '',
                Apply_Addtime: '',
                Apply_AuditNote: '',
                Apply_BPMBizObjectID: '',
                Apply_City: '',
                Apply_ControlDays: '',
                Apply_Country: '',
                Apply_County: '',
                Apply_ID: '',
                Apply_Mobile: '',
                Apply_OrdersID: '',
                Apply_PhoneNumber: '',
                Apply_SN: '',
                Apply_State: '',
                Apply_Status: '',
                Apply_TotalPrice: '',
                Apply_ValidStatus: ''
            },
            Apply_ValidStatusStr: '',
            Apply_StatusStr: '',
            Orders_BPMAuditStatus: '',
            addressStr: '',
            Orders_Delivery_ERPSN: '',
            Orders_Delivery_ID: '',
            ischeck: true
        };
    },
    watch: {
        dialogVisible(newval, oldval) {
            if (newval) {
                this.onInitData();
            }
        }
    },
    computed: {
        totalPrice() {
            let sum = 0;
            this.tableData.map((item) => {
                sum += Number(item.AmountPrice);
            });
            return sum.toFixed(2);
        }
    },
    methods: {
        //关闭弹窗
        handleClose() {
            this.$emit('handleClose', false);
        },
        onClose() {
            this.isShowDialog = false;
        }, // 查看BPM审核
        searchBpm(e) {
            if (!this.detailsInfo.Apply_BPMBizObjectID) {
                this.$message.warning('业务对象ID不存在');
                return;
            }
            this.isSwitch = true;
        },
        setSwitchClose() {
            this.isSwitch = false;
        },

        //初始化数据
        async onInitData() {
            this.isShowDialog = false;
            this.tableData = [];
            this.tableData1 = [];
            this.Apply_ValidStatusStr = '';
            this.Apply_StatusStr = '';
            this.addressStr = '';
            this.Orders_Delivery_ERPSN = '';
            this.Orders_Delivery_ID = '';
            this.detailsInfo = {
                Apply_Accepter: '',
                Apply_Address: '',
                Apply_Addtime: '',
                Apply_AuditNote: '',
                Apply_BPMBizObjectID: '',
                Apply_City: '',
                Apply_ControlDays: '',
                Apply_Country: '',
                Apply_County: '',
                Apply_ID: '',
                Apply_Mobile: '',
                Apply_OrdersID: '',
                Apply_PhoneNumber: '',
                Apply_SN: '',
                Apply_State: '',
                Apply_Status: '',
                Apply_TotalPrice: '',
                Apply_ValidStatus: ''
            };
            this.GetSPCOrdersDeliveryApplyByID();
            this.SPCOrders_DeliveryApply_Goods();
        },
        //点击查看发货单
        getViewReceipt() {
            this.isShowDialog = true;
        },
        //获取详情信息
        GetSPCOrdersDeliveryApplyByID() {
            this.$newsApi.GetSPCOrdersDeliveryApplyByID({ Apply_ID: this.id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.detailsInfo = res.data.data;
                    this.detailsInfo.Apply_Addtime = this.detailsInfo.Apply_Addtime;
                    this.getOrdersDeliveryApplyValidStatus();
                    this.getOrdersBPMAuditStatus();
                    this.getDisplayAddress();
                }
            });
        },
        //获取付款列表
        getOrdersDliveryApplyDistributet() {
            this.$newsApi.getOrdersDliveryApplyDistributet({ Apply_ID: this.id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.tableData1 = res.data.data;
                }
            });
        },
        //获取付款列表
        async getOrdersByID(ordersid) {
            await this.$newsApi.order.getOrdersByID({ id: ordersid }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.orders = res.data.data.Orders_SN;
                }
            });
        },
        //获取详情商品表格内容
        SPCOrders_DeliveryApply_Goods() {
            this.$newsApi.SPCOrders_DeliveryApply_Goods({ Apply_ID: this.id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.tableData = res.data.data;
                }
            });
        },
        //获取地址
        getDisplayAddress() {
            getDisplayAddressStr(
                this.detailsInfo.Apply_Country,
                this.detailsInfo.Apply_State,
                this.detailsInfo.Apply_City,
                this.detailsInfo.Apply_County,
                (result) => {
                    this.addressStr = result.resultinfo;
                    console.log(result);
                },
                (err) => {
                    console.log(err);
                }
            );
        },
        //申请状态获取
        getOrdersDeliveryApplyValidStatus() {
            this.$newsApi.common.getOrdersDeliveryApplyValidStatus({ status: this.detailsInfo.Apply_ValidStatus }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.Apply_ValidStatusStr = res.data.data;
                }
            });
        },
        //审核状态获取
        getOrdersBPMAuditStatus() {
            this.$newsApi.common.getOrdersBPMAuditStatus({ status: this.detailsInfo.Apply_Status }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.Apply_StatusStr = res.data.data;
                }
            });
        },
        goOrderdetail() {
            this.$emit('handleClose', false);
        }
    }
};
</script>

<style lang="scss" scoped>
$--color-primary: #4e6ef2;

/deep/.custom-label {
    width: 8vw;
}
.links {
    color: #409eff;
    cursor: pointer;
}

.hw-form-item-label {
    width: 160px !important;
}

.details-box {
    padding: 0px 20px 20px 20px;
}

.details-box-title {
    position: relative;
    padding-left: 10px;
}

.details-box-title:before {
    content: '';
    width: 4px;
    height: 16px;
    position: absolute;
    top: 0;
    left: 0px;
    background: $--color-primary;
}

.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 140px;
    }
}
</style>